// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3uYH_","inputWrap":"styles_inputWrap__OT0QA","input":"styles_input__2ocRp"};